import React, { useEffect, useState } from "react";
import { HeaderCaption, Space, Title, Main, CardSection, Container, CardTitle, CardFooter, CardHeader } from "./DynamicCardStyles";
const DynamicCard = ({ CardRadius,isCardRadius, bgImgSize, Radiusnone,isDarkForKudzu, HeaderRadius, isHeaderCaption, isSpace, heading, isHome, subheading, isActive, Cardcaption, Cardsubcaption, children, header, HeaderContent, footer, cardHeight, footerContent, cardWidth, isPerk, isProfile, isWhite, backgroundColor, isIFrame = false, isDark,bgImage,isFromSmioneCard , IsProgress, IsSecuredCardPromotion, isBillPayHeaderBg = false}) => {
  
  return (
    <>
      {/* {!isHeaderCaption &&
        <HeaderCaption>
          <Title>
            {heading}
            {subheading}
          </Title>
        </HeaderCaption>
      }
      {!isSpace &&
        <Space></Space>
      } */}
      <Main>
        {/* <Main style={{width:"80%"}}> */}
        <CardSection CardRadius={CardRadius} isCardRadius={isCardRadius} isPerk={isPerk} isProfile={isProfile} isWhite={isWhite} isDark={isDark} isDarkForKudzu={isDarkForKudzu} Radiusnone={Radiusnone} IsProgress={IsProgress} IsSecuredCardPromotion={IsSecuredCardPromotion}>
          {!header &&
            <CardHeader className={isFromSmioneCard ? "smiOneCard" : ''} backgroundColor={backgroundColor} bgImgSize={bgImgSize} HeaderRadius={HeaderRadius} isActive={isActive} bgImage={bgImage} isBillPayHeaderBg={isBillPayHeaderBg} >
              {HeaderContent}
            </CardHeader>
          }
          {isIFrame ?
            <div className={`w-full ${HeaderRadius ? 'rounded-tl-[4rem] rounded-br-[4rem]' : 'rounded-tr-[4rem] rounded-bl-[4rem]'} `}>
              {children}
            </div>
            :

            <Container style={{ width: cardWidth }} isWhite={isWhite}>
              <CardTitle isPrimary>{Cardcaption}</CardTitle>
              {children}
            </Container>
          }

          {!footer &&
            <CardFooter style={{ position: (cardHeight !== 'content-fit' && cardHeight !== null) ? 'absolute' : '', bottom: (cardHeight !== 'content-fit' && cardHeight !== null) ? '0' : '' }}>
              {footerContent}
            </CardFooter>
          }
        </CardSection>
      </Main>
    </>
  );
};

export default DynamicCard;